<template lang="pug">
v-container( fluid fill-height class="tw-p-0 tw-m-0 tw-h-full")
    v-row(v-if="contacts.length > 0"  align="start" justify="center" class="tw-h-full tw-max-h-full tw-bg-gray-lighten-4 tw-rounded tw-border tw-px-0 tw-border-gray-lighten-3 tw-overflow-y-auto")
        v-col(cols="12" class="tw-px-1 tw-pt-1 tw-h-full tw-max-h-full")
            kubiqa-contacts-contact-list-item(v-for="contact in contacts" :key="contact.id" :item="contact"  :entityType="entityType" action="unlink")
    v-row(v-else align="center" justify="center" class="tw-h-full tw-max-h-full tw-bg-gray-lighten-4 tw-rounded tw-border tw-border-gray-lighten-3")
        v-col(cols="auto" class="") 
            div()
                v-lottie-player(
                    :loop="false"
                    width="200px"
                    height="200px"
                    :animation-data="require('@/assets/animations/avatar-outline.json')"
                )
            div(class="tw-text-center")
                span() Add contacts
                    
</template>
<script>
export default {
    props:{
        entityType: {
            type: String,
            default: null
        }
    },
    computed: {
        contacts(){
            return this.$store.getters[ this.entityType + '/contacts/list']
        }
    }

}
</script>